import React, { useState, useEffect } from 'react';
import { Box, Typography, Card, Grid2, CardActionArea, CardContent, CardMedia, Button, Container, TextField, List, ListItem } from '@mui/material';
import Carousel from 'react-material-ui-carousel'; 
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../firebase/firebase';
import Footer from '../components/Footer';

const HomePage = () => {
  const [searchInput, setSearchInput] = useState('');
  const [filteredCourses, setFilteredCourses] = useState([]);
  const [courses, setCourses] = useState([]);
  const [carouselItems, setCarouselItems] = useState([]);

  useEffect(() => {
    const fetchCoursesAndCarousel = async () => {
      const coursesCollection = collection(db, 'courses');
      const courseSnapshot = await getDocs(coursesCollection);
      const courseList = courseSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setCourses(courseList);

      const carouselCollection = collection(db, 'carouselItems');
      const carouselSnapshot = await getDocs(carouselCollection);
      const carouselList = carouselSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setCarouselItems(carouselList);
    };
    fetchCoursesAndCarousel();
  }, []);

  const handleCourseClick = (courseName) => {
    window.open(`/course/${courseName}`, '_blank');
  };

  const handleSearchChange = (event) => {
    setSearchInput(event.target.value);
  };

  const handleSearch = () => {
    if (searchInput.length >= 3) {
      const filtered = courses.filter(course => 
        course.name.toLowerCase().includes(searchInput.toLowerCase())
      );
      setFilteredCourses(filtered);
    } else {
      setFilteredCourses([]);
    }
  };

  return (
    <Container maxWidth="lg" sx={{ mt: 6 }}>
      <Box sx={{ display: 'flex', mb: 2 }}>
        <TextField
          variant="outlined"
          placeholder="Search for courses..."
          value={searchInput}
          onChange={handleSearchChange}
          fullWidth
        />
        <Button variant="contained" onClick={handleSearch} sx={{ ml: 2 }}>
          Search
        </Button>
      </Box>
      {filteredCourses.length > 0 && (
        <List>
          {filteredCourses.map((course, index) => (
            <ListItem button key={index} onClick={() => handleCourseClick(course.name.toLowerCase().replace(/\s+/g, '-'))}>
              {course.name}
            </ListItem>
          ))}
        </List>
      )}
      <Typography variant="h4" sx={{ mb: 3, fontWeight: 'bold' }}>
        Featured Courses
      </Typography>
      <Carousel autoPlay={true} animation="slide" interval={5000} navButtonsAlwaysVisible={false} >
        {carouselItems.map((course, index) => (
          <Card key={index} sx={{ maxHeight: 400 }}>
            <CardActionArea onClick={() => handleCourseClick(course.title.toLowerCase().replace(/\s+/g, '-'))}>
              <CardMedia
                component="img"
                height="300"
                image={course.imageUrl}
                alt={course.title}
              />
              <CardContent>
                <Typography variant="h5" component="div">
                  {course.title}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {course.description}
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        ))}
      </Carousel>

{/* Categories Section 
      <Typography variant="h4" sx={{ mt: 6, mb: 2, fontWeight: 'bold' }}>
        Categories
      </Typography>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', mb: 4 }}>
        {categories.map((category, index) => (
          <Button 
            key={index} 
            variant="outlined" 
            color="primary" 
            sx={{ m: 1, textTransform: 'none' }}
            endIcon={<ArrowForwardIcon />}
          >
            {category}
          </Button>
        ))}
      </Box>
*/}
      {/* Courses Section */}
      <Typography variant="h4" sx={{ mt: 6, mb: 2, fontWeight: 'bold' }}>
        Courses
      </Typography>
      <Grid2 container spacing={4}>
        {courses.map((course, index) => (
          <Grid2 item key={index} xs={12} sm={6} md={4}>
            <Card>
              <CardActionArea onClick={() => handleCourseClick(course.name.toLowerCase().replace(/\s+/g, '-'))}>
                <CardMedia
                  component="img"
                  height="180"
                  image={course.image}
                  alt={course.name}
                />
                <CardContent>
                  <Typography variant="h6" component="div">
                    {course.name}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    By {course.author}
                  </Typography>
                  <Typography variant="body1" sx={{ fontWeight: 'bold', mt: 1 }}>
                    {course.price}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid2>
        ))}
      </Grid2>
      <Footer />
    </Container>
  );
};

export default HomePage;